<div class="flex justify-end">
  <app-close-chip (closed)="onCancel()" />
</div>
<h2 mat-dialog-title *ngIf="title">{{ title | translate }}</h2>
<mat-dialog-content class="!pt-2">
  <p *ngIf="description" class="text-sm font-normal text-default-gray m-0 mb-4">
    {{ description | translate }}
  </p>
  <form [formGroup]="form">
    <mat-form-field class="w-full" appearance="outline" [subscriptSizing]="'dynamic'">
      <mat-label>{{ label | translate }}</mat-label>
      <input matInput [type]="inputType" formControlName="value" [required]="required">
      <mat-error *ngIf="form.get('value')?.touched && form.get('value')?.invalid">
        <span *ngIf="form.get('value')?.errors?.['required']">{{ (errorMessages.required || 'common.forms.required') | translate }}</span>
        <span *ngIf="!form.get('value')?.errors?.['required'] && form.get('value')?.errors?.['pattern']">{{ (errorMessages.pattern || 'common.forms.required') | translate }}</span>
      </mat-error>
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button color="accent" type="button" [disabled]="isLoading" (click)="onSubmit()">
    {{ 'common.forms.submit' | translate | uppercase }}
  </button>
</mat-dialog-actions>
